<div class="row" [scAnchorTarget]="'CV'" *ngIf="candidate">
  <div class="col-12">

    <section>


      <div class="pretitle mb-3">{{ texts.title | localize }}</div>

      <p class="mb-4" *ngIf="!candidate.Education?.length">
        {{ texts.noInformation | localize }}
      </p>

      <ul class="list-group list-group-flush fw-normal">

        <li *ngFor="let entry of candidate.Education" class="list-group-item">

          <div class="row">

            <div class="col-12 col-md">
              <h6 class="mb-1">{{entry.Title}}</h6>
              <p class="mb-0">{{entry.Degree}}</p>
              <p class="mb-0">{{entry.Institute}}</p>
            </div>

            <div class="col-12 col-md-auto mt-2 mt-md-0">

              <p *ngIf="!entry.ToPresent && entry.Start && entry.End && entry.Start != entry.End"
                class="small text-right mb-0">
                {{ entry.Start | date:'MM/y'}} {{ texts.to | localize }} {{ entry.End | date:'MM/y'}}<br>
                <span>{{ entry.Start | humanizedDateDiff : entry.End }}</span>
              </p>

              <p *ngIf="!entry.ToPresent && entry.Start && entry.End && entry.Start == entry.End"
                class="small text-right mb-0">
                {{ entry.Start | date:'MM/y'}}<br>
                <span>{{ texts.aboutOneMonth | localize }}</span>
              </p>

              <p *ngIf="!entry.ToPresent && entry.Start && !entry.End" class="small text-right mb-0">
                {{ entry.Start | date:'MM/y'}}<br>
                <span>{{ texts.unknownDuration | localize }}</span>
              </p>

              <p *ngIf="entry.ToPresent && entry.Start" class="small text-right mb-0">
                {{ entry.Start | date:'MM/y'}} {{ texts.toPresent | localize }}<br>
                <span *ngIf="entry.Start">{{ entry.Start | humanizedDateDiff }}</span>
              </p>

              <p *ngIf="entry.ToPresent && !entry.Start" class="small text-right mb-0">
                {{ texts.toPresent | localize }}<br>
                <span *ngIf="entry.Start">{{ texts.unknownDuration | localize }}</span>
              </p>

            </div>

          </div>

        </li>

      </ul>

    </section>


  </div>
</div>

<div class="row mt-5" *ngIf="candidate?.CvFile || candidate?.Files?.length">
  <div class="col-12 col-lg-6">
    <sc-item-file *ngIf="candidate.CvFile" [name]="texts.cvFileName | localize" [uri]="candidate.CvFile" type="pdf"
      size="1.3 MB" openOnClick="true"></sc-item-file>
    <sc-item-file *ngFor="let f of candidate.Files" [name]="f.Name" [uri]="f.Uri" [type]="f.Type" size="1.3 MB"
      openOnClick="true"></sc-item-file>
  </div>
</div>